// extracted by mini-css-extract-plugin
export default {"page":"sign_page__OhZIB","content":"sign_content__WkrqP","form":"sign_form__6qSez","submit":"sign_submit__5D2M3"};